export default __webpack_public_path__ + "static/media/gallery_03.05399e51.jpg";